// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yug0","toggle":"styles_toggle__3yH8T","preview":"styles_preview__1kCpZ"};